import { Flex } from '@ui-library/flex';
import styled from 'styled-components';
import { H4, Subtext } from '@ui-library/typography';
import { Button } from '@ui-library/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StyledFlex = styled(Flex)`
  background: ${({ theme }) => theme.token.colorBgContainer};
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
  border-radius: ${({ theme }) => theme.token.borderRadius}px;
  width: 60vw;
  height: 70vh;
  padding: ${({ theme }) => theme.token.paddingXL}px;
`;
export const StyledSubtext = styled(Subtext)`
  color: ${({ theme }) => theme.token.colorTextDescription};
`;
export const StyledErrorBody = styled(Subtext)`
  margin: ${({ theme }) => theme.token.marginLG}px 0;
  flex-grow: 1;
  color: ${({ theme }) => theme.token.colorTextDescription};
  overflow-y: auto;
`;
export const ErrorBackButton = styled(Button)`
  margin-left: ${({ theme }) => theme.token.marginXS}px;
`;

export const CustomModalContainer = styled.div.attrs({
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation(),
})`
  max-height: 100vh;
  border-radius: ${({ theme }) => theme.token.borderRadiusXL}px;
  padding: ${({ theme }) => theme.token.paddingXL}px;
  background: ${({ theme }) => theme.token.colorBgLayout};
  box-shadow: ${({ theme }) => theme.token.boxShadowSecondary};
  overflow-y: auto;
`;
export const CrossIcon = styled(FontAwesomeIcon)`
  margin-bottom: ${({ theme }) => theme.token.marginXS}px;
  cursor: pointer;
`;
export const CustomContent = styled.div<{ hideMargin?: boolean }>`
  ${({ hideMargin, theme }) => (!hideMargin ? `margin: ${theme.token.marginLG}px 0;` : '')}
`;

export const CustomButton = styled(Button)`
  min-width: 88px;
`;

export const ModalHeader = styled(H4)`
  flex-grow: 1;
  max-width: 100%;
`;
